// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__j_Tx4","sm":"Avatar_sm__iOh_Q","xl":"Avatar_xl__m2d1f"};